import {
  SLS_status,
} from "lib/sls";
import {events} from 'lib';

// How many ms to wait between calls to check the scanner progress.
const CHECK_INTERVAL = 1000;

class SLSProgressTracker{
    _interval = undefined;
    _checkProgressPromise = undefined;
    _lastProgress = false;

    start = () => {
        if(this._interval !== undefined) return;

        this._lastProgress = 0;
        this._interval = setInterval(this.checkProgress, CHECK_INTERVAL);
    }

    stop = () => {
        if (this._interval === undefined) return;

        clearInterval(this._interval);
        this._interval = undefined;
    }
    /*If not already checking progress, send a 'status' request to SLS.
    Publish new progress to the event API if progress has been made..*/
    checkProgress = () => {
        if(this._checkProgressPromise !== undefined) return;

        this._checkProgressPromise = SLS_status()
            .then((response) => {

                let progress = response.Progress;

                // If progress is < lastProgress, something went awry,
                // or the test completed and progress went back to 0 (idle).
                // We stop checking progress as a result.
                if (progress < this._lastProgress || this._interval === undefined){
                    this.stop();
                    return;
                };
                this._lastProgress = progress;

                events.publish('scanner.progress', response.Progress);
            })
            .catch((err) => {
                console.warn("Error retrieving progress from SLS service.", err);
            })
            .finally(() => {
                this._checkProgressPromise = undefined;
            });
    }
}

let slsProgressTracker = new SLSProgressTracker();
export default slsProgressTracker;